var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { SchemaModuleUniversal } from './module-universal';
import * as rawJSONSchemaModuleGeneralPractice from '../../schemas/module-general-practice.json';
var SchemaModuleGeneralPractice = (function (_super) {
    __extends(SchemaModuleGeneralPractice, _super);
    function SchemaModuleGeneralPractice() {
        var _this = _super.call(this) || this;
        _this.loadSchema(rawJSONSchemaModuleGeneralPractice);
        return _this;
    }
    return SchemaModuleGeneralPractice;
}(SchemaModuleUniversal));
export { SchemaModuleGeneralPractice };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/forms/module-general-practice.ts.pre-build-optimizer.js